module.exports = __webpack_public_path__ + "static/visionar_augmented_reality_how_augmented_reality_really_works-9fcd478cfb2c087e145fbb59347a198b.jpg";